// extracted by mini-css-extract-plugin
module.exports = {"keybindsList":"KeybindsModal_keybindsList__IJY3S","button":"KeybindsModal_button__qRJsW"};